import {
  ExportAnnualRequestTypes,
  ExportAnnualResonseTypes,
  ExportAttendanceRecordRequestTypes,
  ExportDataTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllExportService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<ExportDataTypes[]>> => {
  const res = await axiosInstance.get('exports', { params });
  return res.data;
};

export const getExportByCodeService = async (
  code: string,
): Promise<ExportDataTypes> => {
  const res = await axiosInstance.get(`exports/${code}`);
  return res.data.data;
};

export const exportAnnualReportService = async (
  params: ExportAnnualRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/anual-report/${params.year}`);
  return res.data.data;
};

export const exportAttendanceRecordService = async (
  params: ExportAttendanceRecordRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/attendance-record/${params.payrollPeriodId}`);
  return res.data.data;
};

export const exportSalaryRecordService = async (
  params: ExportAttendanceRecordRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/salary-record/${params.payrollPeriodId}`);
  return res.data.data;
};

export const exportOutOfMainService = async (
  params: ExportAttendanceRecordRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/transfer-out-of-main/${params.payrollPeriodId}`);
  return res.data.data;
};

export const exportTransferInMainService = async (
  params: ExportAttendanceRecordRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/transfer-in-main/${params.payrollPeriodId}`);
  return res.data.data;
};

export const exportMonthlyReportService = async (
  params: ExportAnnualRequestTypes,
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/monthly-report/${params.year}`, {
    month: params.month,
  });
  return res.data.data;
};

export const exportPayrollSummaryService = async (
  params: { year: string },
): Promise<ExportAnnualResonseTypes> => {
  const res = await axiosInstance.post(`exports/payroll-summary/${params.year}`);
  return res.data.data;
};
